import { render } from "./Differences.vue?vue&type=template&id=da3b1cb4&scoped=true"
import script from "./Differences.vue?vue&type=script&lang=js"
export * from "./Differences.vue?vue&type=script&lang=js"

import "./Differences.vue?vue&type=style&index=0&id=da3b1cb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3b1cb4"]])

export default __exports__